export default __webpack_public_path__ + "static/media/brand.4bbfb2e1.jpg";